export const GA_TRACKING_ID = process.env.NEXT_PUBLIC_ENV === 'production' ? 'AW-325182781'
  : '';
export const pageview = (url) => {
  if(window.gtag) {
    window.gtag('config', GA_TRACKING_ID, {
      page_path: url,
    });
  }
};

export const event = ({ action, category, label, value }) => {
  if(window.gtag) {
    window.gtag('event', action, {
      event_category: category,
      event_label: label,
      value: value,
    });
  }
};

export const adRoll_conversion_value = (data) => {
  if(window.adroll){
    window.adroll.track("purchase", {
      "ORDER_ID": `${data.transaction_id}`,
      "conversion_value": `"${data.price}"`,
      "currency": "USD",
      "products": [
      {
        "price": `"${data.price}"`,
        "product_id":`"${data.productId}"`,
        "quantity": "1"
      }]
    }); 
  }
}
